import { Box, FormControl, FormControlLabelProps, FormLabel, Stack, Tooltip } from '@chronosphereio/chrono-ui';
import { InformationOutline as InfoIcon } from 'mdi-material-ui';
import React from 'react';
import { useId } from '../../../components/utils';

export type OptionsEditorControlProps = Pick<FormControlLabelProps, 'label' | 'control'> & {
  description?: string;
};

export const OptionsEditorControl = ({ label, control, description }: OptionsEditorControlProps) => {
  // Make sure we have a unique ID we can use for associating labels and
  // controls for a11y.
  const generatedControlId = useId('EditorSectionControl');
  const controlId = `${generatedControlId}-control`;

  const controlProps = {
    id: controlId,
  };

  return (
    <FormControl>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Stack direction="row" alignItems="center" justifyContent="center" spacing={0.5}>
          <FormLabel htmlFor={controlId} sx={{ whiteSpace: 'nowrap' }}>
            {label}
          </FormLabel>
          {description && (
            <Tooltip Content={description}>
              <InfoIcon aria-hidden={false} fontSize="inherit" color="secondary" />
            </Tooltip>
          )}
        </Stack>
        <Box
          sx={{
            textAlign: 'right',
            '.MuiFormControl-root, .MuiSlider-root': {
              width: '210px',
            },
          }}
        >
          {React.cloneElement(control, controlProps)}
        </Box>
      </Stack>
    </FormControl>
  );
};
